<template>
  <div class="col-lg-12 col-md-12">
    <div class="row" v-if="$auth.user().subscription">
      <div class="row" v-if="$auth.user().conference_room_access">
        <card
          :class="'card-'+theme"
          class="col-lg-8 col-md-7"
          v-if="financialModalities&&$auth.user().subscription"
        >
          <div class="card-header">
            <h4 class="card-title">
              <i class="nc-icon nc-grid-45"></i> Cronograma de Estudos
            </h4>
          </div>
          <hr>
          <div class="card-body">
            <div class="row" v-if="loadingSchedule" v-loading="loadingSchedule" id="loading"></div>
            <div
              v-if="!loadingSchedule"
              v-for="(financialModality, index) in financialModalities"
              :key="financialModality.id"
            >
              <h4 class="card-title">
                <small>
                  <i class="nc-icon nc-stre-right"></i>
                  Modalidade {{financialModality.name}}:
                </small>
              </h4>
              <img
                class="img-fluid"
                :src="financialModality.generic_schedule_link"
                alt="Cronograma"
              >
            </div>
          </div>
        </card>

        <card class="col-lg-12 col-md-12" v-if="!financialModalities" :class="'bg-card-'+theme">
          <div class="card-header">
            <h4 class="card-title">
              <i class="nc-icon nc-notification-70"></i> Oops!
            </h4>
          </div>
          <hr>
          <div class="card-body">
            <div class="text-center">
              <h2 class="card-title text-center">
                <small>Wall Street, we have a problem...</small>
              </h2>
              <h2 class="card-title text-center">
                <small>Não há grupos de estudos agendados para o seu plano. Entre em contato com o suporte.</small>
              </h2>
            </div>
          </div>
        </card>

        <card class="col-lg-4 col-md-5" :class="'bg-card-'+theme" v-if="financialModalities">
          <div class="card-header">
            <h4 class="card-title">
              <i class="nc-icon nc-time-alarm"></i> Próximos Estudos
            </h4>
          </div>
          <hr>
          <div class="card-boby text-center">
            <div
              class="row"
              v-if="loadingTodayUserConferenceRoom"
              v-loading="loadingTodayUserConferenceRoom"
              id="loading"
            ></div>
            <div v-else>
              <h4 class="card-title text-center">
                <small>{{conferenceRoomMessage}}</small>
              </h4>
              <hr v-if="conferenceRoomMessage">
              <hr>
              <div>
                <div
                  class="row"
                  style="padding: 10px; margin-bottom: 5px;"
                  v-if="conferenceRoomSchedules"
                  v-for="(conferenceRoomSchedule, index) in conferenceRoomSchedules"
                  :key="conferenceRoomSchedule.id"
                >
                  <div class="col-6">
                    <h5 class="card-title text-left">{{conferenceRoomSchedule.conferenceRoom.data.name}}</h5>
                    <br>
                    <small>Horário*:</small>
                    {{conferenceRoomSchedule.daily_time}}
                  </div>
                  <div class="col-6" style="padding-top: 10px;">
                    <button
                      class="btn btn-round btn-fill btn-sm"
                      :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                      :disabled="!conferenceRoomButton[index]"
                      @click="openModal('centered', conferenceRoomSchedule)"
                    >
                      <i class="nc-icon nc-tap-01"></i> Acessar Aula
                    </button>
                  </div>
                  <hr>
                </div>
                <h4 class="card-title text-center" v-if="!conferenceRoomSchedules">
                  <small>Não há mais grupos de estudos agendados para hoje.</small>
                </h4>
              </div>
            </div>
          </div>
          <el-dialog
            center
            title="Deseja entrar no seguinte grupo de estudo?"
            :visible.sync="modals.centered"
          >
            <div class="text-center" v-if="!conferenceRoomEventConfirmed">
              <h4
                class="card-title text-center"
              >{{currentConferenceRoomSchedule.conferenceRoom.data.name}} às {{currentConferenceRoomSchedule.daily_time}} hrs</h4>
              <br>
              <span slot="footer" class="dialog-footer">
                  <button
                    class="btn btn-default"
                    @click.prevent="submitConferenceRoomEvent()"
                  >Sim, aceito*</button>
                  <button class="btn btn-danger" @click="closeModal('centered')">Cancelar.</button>
                  <hr>
                  <h5 class="card-title text-justify">
                    <small
                      style="white-space: pre-wrap; word-break: keep-all; font-size: 14px; color: #323d47"
                    >*Ao aceitar o acesso ao grupo de estudo, declaro estar ciente que toda atividade da TopTrader é única e exclusivamente educacional. A aplicação do conhecimento obtido no grupo de estudo é de minha inteira responsabilidade.</small>
                  </h5>
                </span>
            </div>

            <div class="text-center" v-if="conferenceRoomEventConfirmed">
              <div
                class="row"
                v-if="loadingConferenceRoomAccess"
                v-loading="loadingConferenceRoomAccess"
                id="loading"
              ></div>
              <div v-if="!loadingConferenceRoomAccess">
                <h4 class="card-title text-center">
                  <i class="nc-icon nc-check-2"></i> Acesso validado com sucesso. Bons estudos.
                </h4>
                <h3
                  class="card-title text-center text-danger"
                >Obs.: Desative seu microfone após entrar.</h3>
                <br>
                <span slot="footer" class="dialog-footer">
                    <a
                      class="btn btn-default"
                      @click="closeModal('centered')"
                      :href="currentConferenceRoomSchedule.conferenceRoom.data.link"
                      target="_blank"
                    >
                      <i class="nc-icon nc-tap-01"></i> Entrar
                    </a>
                  </span>
              </div>
            </div>
          </el-dialog>
          <div class="card-footer text-right">
            <h5 class="card-title">
              <small v-if="conferenceRoomSchedules">*Horário de Brasília</small>
            </h5>
          </div>
        </card>
      </div>
      <!--Subscription-->

      <div v-else class="col-lg-12 col-md-12">
        <card :class="'card-'+theme">
          <div class="card-header">
            <h4 class="card-title">
              <i class="nc-icon nc-notification-70"></i> Oops!
            </h4>
          </div>
          <hr>
          <div class="card-body">
            <div class="text-center">
              <h2 class="card-title text-center">
                <small>Wall Street, we have a problem...</small>
              </h2>
              <h2 class="card-title text-center">
                <small>
                  Você ainda não possui acesso à grupos de estudos.
                  <br>Entre em contato com o suporte para mais informações.
                </small>
              </h2>
            </div>
          </div>
        </card>
      </div>
    </div>
    <!--Access-->

    <div v-else>
      <card :class="'card-'+theme">
        <div class="card-header">
          <h4 class="card-title">
            <i class="nc-icon nc-notification-70"></i> Oops!
          </h4>
        </div>
        <hr>
        <div class="card-body">
          <div class="text-center">
            <h2 class="card-title text-center">
              <small>Wall Street, we have a problem...</small>
            </h2>
            <h2 class="card-title text-center">
              <small>Você não possui assinatura ativa para continuar acompanhando os grupos de estudos.</small>
            </h2>
            <br>
            <router-link
              class="btn btn-round btn-fill"
              :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
              to="/signature"
              href="/performance"
            >Nova Assinatura</router-link>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Loading, Dialog } from "element-ui";
import moment from "moment-timezone";

moment.tz.setDefault("America/Sao_Paulo");
Vue.use(Loading.directive);

export default {
  components: {
    [Dialog.name]: Dialog
  },
  data() {
    return {
      modals: {
        basic: false,
        centered: false,
        custom: false,
        confirm: false
      },
      loadingSchedule: true,
      loadingTodayUserConferenceRoom: true,
      loadingConferenceRoomAccess: false,
      conferenceRoomEventConfirmed: false,
      conferenceRoomButton: [],
      conferenceRoomMessage: "",
      conferenceRoomSchedules: [],
      financialModalities: [],
      currentConferenceRoomSchedule: {
        conferenceRoom: {
          data: {
            teacher: {
              data: {
                user: {
                  data: {}
                }
              }
            }
          }
        }
      }
    };
  },
  methods: {
    openModal(name, conferenceRoom) {
      this.conferenceRoomEventConfirmed = false;
      this.currentConferenceRoomSchedule = conferenceRoom;
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    fetchUser() {
      this.$auth.fetch({
        params: {},
        success: function() {},
        error: function(error) {
          console.log(error);
        }
      });
    },
    fetchConferenceRoomSchedules() {
      this.axios
        .get("/confroomschedules")
        .then(response => {
          this.financialModalities = response.data.data;
          if (this.financialModalities) {
            for (
              let financialModalityIndex = 0;
              financialModalityIndex < this.financialModalities.length;
              financialModalityIndex++
            ) {
              for (
                let conferenceRoomIndex = 0;
                conferenceRoomIndex <
                this.financialModalities[financialModalityIndex].conferenceRooms
                  .data.length;
                conferenceRoomIndex++
              ) {
                if (
                  this.financialModalities[financialModalityIndex]
                    .conferenceRooms.data[conferenceRoomIndex].userSchedules
                    .data.length == 0
                ) {
                  this.financialModalities[
                    financialModalityIndex
                  ].conferenceRooms.data.splice(conferenceRoomIndex, 1);
                }
              }
            }
          }
          this.loadingSchedule = false;
          this.fetchTodaysUserConferenceRoomSchedules();
        })
        .catch(error => {
          console.log(error);
          alert(
            "Erro ao carregar cronograma de grupos de estudos. Tente novamente \n. " + error
          );
        });
    },
    fetchTodaysUserConferenceRoomSchedules() {
      this.axios
        .get("/todaysconferenceroomschedules?include=conferenceRoom")
        .then(response => {
          this.conferenceRoomSchedules = response.data.data;
          this.loadingTodayUserConferenceRoom = false;
          if (this.conferenceRoomSchedules) {
            this.setButton();
          }
        })
        .catch(error => {
          console.log(error);
          alert(
            "Erro ao carregar os grupos de estudos de hoje. Tente novamente \n. " + error
          );
        });
    },
    setButton() {
      for (let conferenceRoomSchedule of this.conferenceRoomSchedules) {
        // Conference Room DateTime
        let dateHourConferenceRoom = moment.tz("America/Sao_Paulo");
        dateHourConferenceRoom.set({
          hour: conferenceRoomSchedule.daily_time.split(":")[0],
          minute: conferenceRoomSchedule.daily_time.split(":")[1],
          second: "00"
        });

        // DateTime Now
        let dateNow = moment.tz("America/Sao_Paulo").toDate();

        // Calculate Time Difference between now and conference room time.
        let diff =
          (dateNow.getTime() - dateHourConferenceRoom.toDate().getTime()) /
          1000;
        diff /= 60 * 60;

        if (diff >= -1 && diff <= 3.8) {
          this.conferenceRoomMessage = "Grupo de estudo disponível";
          this.conferenceRoomButton.push(true);
        } else {
          this.conferenceRoomMessage =
            "Aguarde o próximo grupo de estudo. O link ficará disponível 1 hora antes do início previsto.";
          this.conferenceRoomButton.push(false);
        }
      }
    },
    submitConferenceRoomEvent() {
      // Loading Conference Room Access
      this.loadingConferenceRoomAccess = true;

      this.currentConferenceRoomSchedule.conferenceRoom.data.link = 'https://toptrd.webex.com/join/contatotoptrader'
      // Validating User Access
      this.axios
        .get(
          "/todaysuserevents/conferenceroom/" +
            this.currentConferenceRoomSchedule.id
        )
        .then(response => {
          if (response.data.data) {
            this.conferenceRoomEventConfirmed = true;
            this.loadingConferenceRoomAccess = false;
          } else {
            let eventData = {
              click_action: true,
              confirm_click_action: true,
              conference_room_schedule_id: this.currentConferenceRoomSchedule.id
            };

            this.axios
              .patch("/confenreceroomevents", eventData)
              .then(response => {
                console.log(response);
                this.conferenceRoomEventConfirmed = true;
                this.loadingConferenceRoomAccess = false;
              })
              .catch(error => {
                this.conferenceRoomEventConfirmed = false;
                this.loadingConferenceRoomAccess = false;
                console.log(error);
                alert(
                  "Erro ao validar seu acesso. Tente novamente \n. " + error
                );
              });
          }
        })
        .catch(error => {
          console.log(error);
          alert("Erro ao validar seu acesso. Tente novamente \n. " + error);
        });
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  created() {
    this.fetchUser();
    this.fetchConferenceRoomSchedules();
  }
};
</script>
<style>
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
  .el-loading-spinner .path {
    stroke: #000 !important;
  }

  .el-loading-mask {
    background: transparent !important;
  }
}

.el-dialog {
  width: 50%;
}
@media (max-width: 800px) {
  .el-dialog {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/ConferenceRoom.vue